import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { AppService } from "src/app/core/services/app.service"
import { HttpClient, HttpParams } from "@angular/common/http"

@Injectable()
export class TenantBrandService {
  private getTenantBrandUrl: string

  private buildUrls(tenantUrl: string) {
    this.getTenantBrandUrl =
      tenantUrl + environment.endpointTenantBrand.routes.getBrands
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointTenantBrand.url)
  }

  getTenantBrands() {
    return this.httpClient.get<any>(this.getTenantBrandUrl)
  }
}
